/**
 * Created by mateimisarca on 2019-06-07
 */
 
import Slider from './slider';
export default Slider;
 